export default __webpack_public_path__ + "static/media/cf2.604bdf13.jpg";